import React from 'react';
import { Card, Typography, Steps } from 'antd';
import { useTranslation } from 'react-i18next';

const { Paragraph } = Typography;

const CoffeeMachineInstructions = () => {
  const { t } = useTranslation();
  
  return (
    <Card title={t('coffee.title')} style={{ marginBottom: '24px' }}>
      <Paragraph><em>{t('coffee.subtitle')}</em></Paragraph>
      <Paragraph>
        {t('coffee.intro')}
      </Paragraph>
      
      <Steps
        direction="vertical"
        current={-1}
        items={[
          {
            title: t('coffee.steps.water.title'),
            description: (
              <Paragraph>
                {t('coffee.steps.water.description')}
              </Paragraph>
            ),
          },
          {
            title: t('coffee.steps.power.title'),
            description: (
              <Paragraph>
                {t('coffee.steps.power.description')}
              </Paragraph>
            ),
          },
          {
            title: t('coffee.steps.capsule.title'),
            description: (
              <Paragraph>
                {t('coffee.steps.capsule.description')}
              </Paragraph>
            ),
          },
          {
            title: t('coffee.steps.quantity.title'),
            description: (
              <Paragraph>
                {t('coffee.steps.quantity.description')}
              </Paragraph>
            ),
          },
          {
            title: t('coffee.steps.brew.title'),
            description: (
              <Paragraph>
                {t('coffee.steps.brew.description')}
              </Paragraph>
            ),
          },
          {
            title: t('coffee.steps.remove.title'),
            description: (
              <Paragraph>
                {t('coffee.steps.remove.description')}
              </Paragraph>
            ),
          },
          {
            title: t('coffee.steps.turnoff.title'),
            description: (
              <Paragraph>
                {t('coffee.steps.turnoff.description')}
              </Paragraph>
            ),
          },
        ]}
      />
    </Card>
  );
};

export { CoffeeMachineInstructions };
